import React from "react";
import Page from "../../component/Page/Page";
import ReadpointForm from "../../readpoint/component/ReadpointForm";
import NodeActionForm from "../component/NodeActionForm";

class ReadpointFormPage extends React.Component {
  render() {
    const {match, history} = this.props;
    const breadcrumbs = [];
    return (
      <Page title="Dados do Action" breadcrumbs={breadcrumbs}>
        <NodeActionForm match={match} history={history}/>
      </Page>
    );
  }
}

export default ReadpointFormPage;



// WEBPACK FOOTER //
// ./src/gateways/node/NodeActionFormPage.js